import axios from "axios";

export default function PurchaseorderrequestFormService(formData, method) {
  let id
  let url
  if(formData && formData.id) {
    id = formData.id
    url = process.env.REACT_APP_API_HOST + "/purchase_order_request/" + id
  }
  else {
    url = process.env.REACT_APP_API_HOST + "/purchase_order_request"
  }
  return axios({
    method: method,
    url: url,
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
